module.exports = __webpack_public_path__ + "static/media/imagen_RESPIRE.f3b8cc88.png";